/*global Ractive, RedmarineUXTemplates, BaseComponent */

// Add component to Global Ractive object
Ractive.components['ux-passwordstrength'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxpasswordstrengthUxpasswordstrength,

	// any default data
	data: {
		component: 'ux-passwordstrength',
		strengthCSS: '',
		meterValue: ''
	},

	/**
	* Existing My Account logic to calculate the password strength
	*/
	getPasswordStrength: function(password) {

		var self = this;

		var strength = 0,
			fNumber = false,
			fLower = false,
			fUpper = false,
			fPanctuation = false,
			numbers = '0123456789',
			lowercase = 'abcdefghijklmnopqrstuvwxyz',
			uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
			punctuation = '!.@$£#*()%~<>{}[]?\\\"+-^&';

		if (self.contains(password, numbers) > 0) {
			fNumber = true;
		}
		if (self.contains(password, lowercase) > 0) {
			fLower = true;
		}
		if (self.contains(password, uppercase) > 0) {
			fUpper = true;
		}
		if (self.contains(password, punctuation) > 0) {
			fPanctuation = true;
		}
		if (fNumber === true && (fLower === true || fUpper === true)) {
			strength += 1;
			if (fNumber === true && fLower === true && fUpper === true) {
				strength += 1;
				if (password.length >= 8) {
					strength += 1;
					if (fPanctuation === true) {
						strength += 1;
						if (password.length >= 10) {
							strength += 1;
						}
					}
				}
			}
		} else {
			strength = 0;
			//progState.className = pwd_strength_0;
		}
		return strength;
	},

	/**
	* Used by getPasswordStrength function
	*/
	contains: function(password, validChars) {

		var totalCount = 0,
			i,
			character;
		
		if(!_.isEmpty(password)) {
			for (i = 0; i < password.length; i += 1) {
				character = password.charAt(i);
				if (validChars.indexOf(character) > -1) {
					totalCount ++;
				}
			}
		} 

		return totalCount;
	},

	displaySeparators: function() {
		this.set({
			bar33: '',
			bar66: ''
		});
	},

	hideSeparators: function() {
		this.set({
			bar33: 'hide-bar',
			bar66: 'hide-bar'
		});
	},

	// add you behavious here
	onrender: function() {

		this.observe('password', function(newValue, oldValue) {
						
			var strength = this.getPasswordStrength(newValue);

			var comment = 'Weak';

			switch (strength) {
				case 3: comment = 'Medium';
					this.set('bar33','hide-bar');
					this.set('bar66','');
					break;
				case 4:
				case 5:
					comment = 'Strong';
					this.hideSeparators();
					break;
				default:
					comment = 'Weak';
					this.displaySeparators();
					break;
			}
			
			var strengthCSS = (!_.isEmpty(newValue) ? 's'+strength : '');
			this.set('strengthCSS', strengthCSS)
			this.set('meterValue', (!_.isEmpty(newValue) ? comment : '')); 
		});
	}

});
